import React from 'react';

import { Link } from '@mui/material';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import EyeIcon from '@mui/icons-material/RemoveRedEye';

import classes from './InvoiceRow.module.scss';
import { Invoice } from '../../../../../interfaces/invoice';
import {
  GridTableCell,
  GridTableRow,
  PriceCell,
} from '../../../../../../shared/components/table-components';
import { getFormattedDate } from '../../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../../shared/constants/apiDateFormat';
import { StatusCell } from '../../../../../components/StatusCell/StatusCell';

type InvoiceRowProps = {
  invoice: Invoice;
  onShowDetailsClick: (invoiceId: number) => void;
};

const InvoiceRow = ({ invoice, onShowDetailsClick }: InvoiceRowProps) => {
  const handleShowDetailsClick = () => {
    onShowDetailsClick(invoice.invoiceId);
  };

  return (
    <GridTableRow variant="subRow" className={classes.invoiceRow}>
      <GridTableCell className="private-info">
        {getFormattedDate(invoice.billingDate, localDataFormat)}
      </GridTableCell>
      <StatusCell status={invoice.status} />
      <PriceCell price={invoice.activeClientSeats || 0} />
      <PriceCell price={invoice.saasTax || 0} />
      <PriceCell price={invoice.totalAmount || 0} />
      <div className={classes.actionCell} onClick={handleShowDetailsClick}>
        <EyeIcon fontSize="small" />
        Show Details
      </div>
      {invoice.invoicePdfUrl && (
        <Link className={classes.actionCell} href={invoice.invoicePdfUrl}>
          <DownloadIcon fontSize="small" />
          PDF
        </Link>
      )}
    </GridTableRow>
  );
};

export { InvoiceRow };
